import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Minus = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 11H5C4.4 11 4 11.4 4 12C4 12.6 4.4 13 5 13H19C19.6 13 20 12.6 20 12C20 11.4 19.6 11 19 11Z"
      fill="currentColor"
    />
  </svg>
)

export default Minus
